<template>
  <div class="navigation">
    <el-row :gutter="5">
      <el-col :span="9">
        <el-row :gutter="20" type="flex" justify="center" v-if="isShow" class="logo">
          <el-col :span="10">
            <div style="width: 350px" class="logoImage">
              <a href="/index">
                <el-image :src="logo" lazy>
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </a>
            </div>
          </el-col>
          <el-col class="hidden-md-and-down" :span="14">
            <div class="logotit">中科院院属企业</div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :span="10">
        <!-- 不知道为啥，这儿会莫名其妙出现30px的上下padding -->
        <div class="header" style="padding:0">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item v-for="(item,index) in menus" :index="item.index" :key="index">{{ item.name }}</el-menu-item>
          </el-menu>
          <div style="clear:both"></div>
        </div>
      </el-col>
      <el-col :span="5">
        <div v-if="isShow" class="last">
          <el-link href="http://admin.casmrc.cn">登录</el-link>
          <div class="phone">加盟电话 ： 400-8355-708</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HeadMenu',
  data () {
    return {
      isShow: true,
      activeIndex: '1',
      fullWidth: 0,
      logo: require('../../assets/logo_white.png'),
      menus: [
        {
          index: '/index',
          name: '首页'
        },
        {
          index: '/production',
          name: '产品中心'
        },
        {
          index: '/about',
          name: '关于我们'
        },
        {
          index: '/business',
          name: '招商加盟'
        },
        {
          index: '/news',
          name: '新闻中心'
        }
      ]
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleSelect (key, b, c) {
      this.$emit('keyChange', key)
    },
    handleResize () {
      this.fullWidth = document.documentElement.clientWidth
      if (this.fullWidth < 830) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.navigation {
  overflow: hidden;
  background-color: #545c64;

  .logo {
    text-align: center;
    line-height: 60px;
    //width: 28%;
    height: 60px;
    min-width: 190px;
    float: left;
    overflow: hidden;

    .logoImage {
      min-width: 120px;

      .el-image {
        float: left;
        height: 38px;
        width: 150px;
        top: 11px;
        margin-left: 18%;
        margin-right: 20px
      }
    }

    .logotit {
      //overflow:hidden;
      margin-left: 20px;
      font-size: 30px;
      color: white;
    }
  }

  .header {
    float: left;
    height: 60px;
    //width:500px;
    overflow: hidden;

    .el-menu {
      .el-menu-item {
        list-style: none;
        overflow: hidden;
      }
    }
  }

  .last {
    overflow: hidden;
    float: left;

    .el-link.el-link--default {
      float: left;
      line-height: 60px;
      color: white;

      &:hover {
        color: rgb(255, 208, 75);
      }
    }

    .phone {
      float: right;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-left: 20px;
      text-align: center;
      line-height: 60px;
      color: rgb(255, 208, 75);
    }
  }
}

</style>
